<template>
    <div id="nav" :style="{ display : ( $vuetify.breakpoint.mdAndUp ? 'flex' : 'block' )}">
        <transition v-if="$vuetify.breakpoint.mdAndUp" name="fade">
          <router-link v-if="!toggled" class="navItem"  to="/work">Work</router-link>
        </transition>
        <router-link v-else class="navItem"  to="/work">Work</router-link>
        <ContactToggle v-if="!$vuetify.breakpoint.smAndDown"/>
        <router-link v-else to="/contact">Contact</router-link>
    </div>
</template>

<script>
import ContactToggle from '@/components/ContactToggle.vue'
export default {
  components: {
    ContactToggle
  },
  computed: {
    toggled () { return this.$store.state.contactToggle }
  }
}
</script>

<style lang="scss">
#nav{
    z-index: 100000;

    a{
    //right: 30px;
    font-size: 20px;
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    //text-align: right;
    color: white;
    text-decoration: none;
    letter-spacing: -0.035em;
  }
  .fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
</style>
